export default function PricingContainer(props) {
    return (
        <div id="generic_price_table">
            {props.children}
        </div>
    );
}